import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { ConsorsSubscriptionsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    subscriptionIdentifier?: string;
};

export const schemaLoanRequestResolver_GetConsorsSubscriptionStatus = ConsorsSubscriptionsTableDefinitionZod.pick({
    cancellationStatus: true,
    documentDownload: true,
    errors: true,
    failureReason: true,
    status: true,
    subscriptionIdentifier: true,
    timestamp: true,
    warning: true,
}).nullable();

export type SchemaLoanRequestResolver_GetConsorsSubscriptionStatus = z.infer<
    typeof schemaLoanRequestResolver_GetConsorsSubscriptionStatus
>;

export type LoanRequestResolver_GetConsorsSubscriptionStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetConsorsSubscriptionStatus
>;
